module.exports = __webpack_public_path__ + "img/poster.154300fa.jpg";